import React from 'react';

import { HelpDialogField } from '@/components/primitive';

export const capabilityHelperCopy = (
  <>
    <HelpDialogField fieldName="Dependencies">
      Lists other Capabilities that are either <em>upstream</em> or <em>downstream</em> dependencies
      of this Capability.
    </HelpDialogField>
    <HelpDialogField fieldName="SLI">
      The ratio of <em>good events</em> to <em>total events</em>, expressed as a percentage,
      measured over the compliance period of 28 days.
    </HelpDialogField>
    <HelpDialogField fieldName="SLO">The target for SLI attainment.</HelpDialogField>
    <HelpDialogField fieldName="Error Budget">
      The error budget represents how much leeway you have with your SLI before it starts breaching
      the SLO. A negative error budget means the SLO has already been breached.
    </HelpDialogField>
    <HelpDialogField fieldName="Latest Data">
      The most recent datapoint that Tome has collected for this SLO. All times are in UTC.
    </HelpDialogField>
  </>
);
